module.exports = __webpack_public_path__ + "img/main-old~11.09.2026.ecdcf4b8.jpg";